export default "__VITE_ASSET__2F9SXcTh__"